import React from "react";
import {
  Box,
  createTheme,
  Divider,
  ThemeProvider,
  Typography,
} from "@mui/material";
import SwiperComp from "../components/otherPageComponent/SwiperComp";
import GalleryGrid from "../components/otherPageComponent/GalleryGrid";
import SEO from "../components/SEO";

const theme = createTheme();

function GalleryPage() {
  return (
    <>
      <SEO
        title="Gallery - Aastha Computers"
        description="Browse the gallery of Aastha Computes, Bikaner to see our classrooms, events, workshops, and student achievements. Experience our vibrant learning environment visually."
        pagePath="/gallery"
      />
      <Box sx={{ padding: 4, backgroundColor: "#f0f0f0" }}>
        <Typography
          variant="h4"
          sx={{
            textAlign: "center",
            marginBottom: 2,
            fontWeight: "bold",
            color: "#333",
            textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
          }}
        >
          Our Memories 🫶🏻❤️
        </Typography>
        <Box
          sx={{
            // position: "relative",
            // height: "300px",
            // display: "flex",
            // flexDirection: "column",
            // justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            marginBlock: "0.8rem",
            padding: 2,
            backgroundColor: "white",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            borderRadius: "16px",
            gap: "0.8rem",
          }}
        >
          <SwiperComp />
        </Box>
        <Divider sx={{ marginBlock: 4 }} />
        <Typography
          variant="h4"
          sx={{
            textAlign: "center",
            marginBottom: 3,
            fontWeight: "bold",
            color: "#333",
            textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
          }}
        >
          Timeless Treasures 🕰️📖
        </Typography>
        <Box
          sx={{
            // position: "relative",
            // height: "300px",
            // display: "flex",
            // flexDirection: "column",
            // justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            marginBlock: "0.8rem",
            padding: 2,
            backgroundColor: "white",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            borderRadius: "16px",
            gap: "0.8rem",
          }}
        >
          <ThemeProvider theme={theme}>
            <GalleryGrid />
          </ThemeProvider>
        </Box>
      </Box>
    </>
  );
}

export default GalleryPage;
